'use client';

import { c as _c } from "react/compiler-runtime";
import { SegmentPicker } from '@/domains/pages/ai-proficiency/components/segment-picker';
import { SegmentDimensionMappingTrigger } from '@/domains/pages/shared/segment-dimension-mapping-trigger';
import type { UpskillingView } from '@/domains/pages/ai-proficiency/hooks/use-upskilling-page-data';
import type { SegmentSummary } from '@/domains/pages/ai-proficiency/utils/map-segment-aggregates';
import { SegmentScopeTabs } from '@/domains/pages/shared/segment-scope-tabs';
import { SegmentScopeSegmentControls } from '@/domains/pages/shared/segment-picker-row';
import type { SegmentKind } from '@/domains/pages/shared/segment-kind';
import { cn } from '@/utils/shad';
type UpskillingScopeBarProps = {
  view: UpskillingView;
  onViewChange: (view: UpskillingView) => void;
  segments: SegmentSummary[];
  selectedSegmentName: string;
  onSelectSegment: (name: string) => void;
  className?: string;
};
export function UpskillingScopeBar(t0) {
  const $ = _c(14);
  const {
    view,
    onViewChange,
    segments,
    selectedSegmentName,
    onSelectSegment,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex flex-nowrap items-center gap-2 border-b border-b-lightborder px-8 py-2", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onViewChange || $[3] !== view) {
    t2 = <SegmentScopeTabs value={view} onValueChange={onViewChange} />;
    $[2] = onViewChange;
    $[3] = view;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== onSelectSegment || $[6] !== segments || $[7] !== selectedSegmentName || $[8] !== view) {
    t3 = view !== "all" && segments.length > 0 ? <SegmentScopeSegmentControls picker={<SegmentPicker segments={segments} selectedName={selectedSegmentName} onSelect={onSelectSegment} />} trailing={<SegmentDimensionMappingTrigger segmentKind={view as SegmentKind} />} /> : null;
    $[5] = onSelectSegment;
    $[6] = segments;
    $[7] = selectedSegmentName;
    $[8] = view;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t1 || $[11] !== t2 || $[12] !== t3) {
    t4 = <div className={t1} data-testid="upskilling-scope-bar">{t2}{t3}</div>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}